module.exports = __webpack_public_path__ + "static/media/ntvk.67709aa1.JPG";